import React from 'react';
import { observer } from 'mobx-react';

import style from './PatientApp.module.scss';

import { store } from '@store';

import { PatientAppIndicator } from './PatientAppIndicator';
import { SubscriptionChip } from './SubscriptionChip';

interface Props {
    hideAppLabel?: boolean;
    hideSubscriptionLabel?: boolean;
}

export const PatientApp = observer(({ hideAppLabel, hideSubscriptionLabel }: Props): React.ReactElement<any> => {
    const { ehr } = store;

    return (
        <div className={style.root}>
            <PatientAppIndicator
                patientId={ehr.id}
                hideLabel={hideAppLabel}
            />
            <SubscriptionChip
                patientId={ehr.id}
                hideLabel={hideSubscriptionLabel}
            />
        </div>
    );
});
